import { io } from "socket.io-client";
import Emitter from 'component-emitter';
import { GET_TOKEN, REFRESH_TOKEN } from "@/store/constants";
import store from "@/store";
export const ERROR_CAPTURE_SOCKET = {
  socket: null,
  connected: false,
  connecting: false,
  init(){
    Emitter(this)
    window.ERROR_CAPTURE_SOCKET = this
    return this
  },
  connect(){
    if(this.connecting) return;
    try {
      this.connecting=true
      if(this.connected) throw new Error('Already Connected')
      this.socket = io(`${new URL(process.env.VUE_APP_ERROR_CAPTURE_URL).origin}/admin`,{
        autoConnect: false,
        closeOnBeforeunload: true,
        reconnection: true,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 5,
        auth: {
          token: store.getters[GET_TOKEN]
        },
      });
      this.socket.on('connect',this.onConnect.bind(this))
      this.socket.on('disconnect',this.onDisconnect.bind(this))
      this.socket.on("connect_error", this.onConnectError.bind(this));
      this.socket.onAny(this.onAnyEvent.bind(this));
      this.socket.connect()
    } catch (ex) {
      console.log('ERROR CAPTURE SOCKET connect error',ex)
      throw ex
    } finally {
      this.connecting=false
    }
  },
  disconnect(){
    this.socket?.disconnect?.()
  },
  onConnect(){
    console.log('ERROR CAPTURE SOCKET connected')
    this.connected=true
    this.emit('connect')
  },
  async onConnectError(err){
    try {
      console.log('ERROR CAPTURE SOCKET connect error',err,this.socket?.active)
      if(!this.socket?.active) {
        await store.dispatch(REFRESH_TOKEN)
        this.socket.auth.token = store.getters[GET_TOKEN];
        this.socket.connect();
      }
    } catch (ex) {
      console.log('ERROR CAPTURE SOCKET connect error exception',ex)
    }
  },
  onDisconnect(reason){
    console.log('ERROR CAPTURE SOCKET disconnect',reason,this.socket?.active)
    this.connected=false
    if (!this.socket?.active) {
      if (reason=='io client disconnect') {
        this.socket=null
        this.socket?.off()
      }
    }
  },
  async onAnyEvent(event,...args){
    try {
      this.emit(event,...args)
    } catch (ex) {
      console.log('ERROR CAPTURE SOCKET any event exception',ex)
    }
  },
}